import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { useTrialStatus } from '@/modules/plans/hooks/useTrialStatus'

export default function OportunidadesTrialBanner() {
  const { inTrial, daysLeft, loading, error } = useTrialStatus()

  if (loading) return null
  if (error) return null
  if (!inTrial || daysLeft <= 0) return null

  const label = daysLeft === 1 ? '1 dia' : `${daysLeft} dias`

  return (
    <div className="mb-4 rounded-lg border border-emerald-500/50 bg-emerald-500/15 px-3 py-3 text-xs text-emerald-50 md:px-4 md:py-3 md:text-sm">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-2">
          <div className="mt-[2px] rounded-full bg-emerald-500/30 p-1.5 text-emerald-50">
            <AlertTriangle className="h-4 w-4" />
          </div>
          <div>
            <div className="font-semibold">
              Você está no teste gratuito ({label} restantes)
            </div>
            <div className="mt-0.5 text-emerald-50/90">
              Durante o teste, você tem acesso às mesmas moedas e oportunidades dos assinantes Elite. Aproveite para sentir na prática o potencial dos alertas.
            </div>
          </div>
        </div>
        <div className="text-[11px] text-emerald-100/80 md:text-xs">
          Ao fim do teste, você poderá escolher um plano e continuar usando normalmente.
        </div>
      </div>
    </div>
  )
}

